export const CURRENT_YEAR = new Date().getFullYear();

export const LINKS_MAP = {
  help: {
    contentKey: 'help',
    useFunction: 'generateHelpLink',
  },
  imprint: {
    contentKey: 'imprint',
    path: 'imprint',
  },
  legalhub: {
    contentKey: 'legal',
    path: 'ua/legalhub-full',
  },
  policies: {
    contentKey: 'policies',
    path: 'popup/about-payment-methods',
  },
  privacy: {
    contentKey: 'privacy',
    path: 'ua/privacy-full',
  },
  serviceDescription: {
    contentKey: 'serviceDescription',
    path: 'ua/servicedescription-full',
  },
  userAgreement: {
    contentKey: 'userAgreement',
    path: 'ua/useragreement-full',
  },
};
